import { render, staticRenderFns } from "./add_project.vue?vue&type=template&id=5b86a430&scoped=true"
import script from "./add_project.vue?vue&type=script&lang=js"
export * from "./add_project.vue?vue&type=script&lang=js"
import style0 from "./add_project.vue?vue&type=style&index=0&id=5b86a430&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b86a430",
  null
  
)

export default component.exports